/**
 * Administration controller
 */

import '@images/i-menu.png';
export default class {
  boot() {
    console.log('Abbott - Data Layer: administration loaded');
  }
}
